<ng-container *ngIf="globalLoading">
  <div class="loading-spinner z-3 container-fluid position-absolute top-0 left-0 w-100 h-100 bg-light"
       style="--bs-bg-opacity: .8;">
    <div class="row">
      <div class="col-12 vh-100">
        <app-spinner
        [spinnerCheckmark]="true"
        ></app-spinner>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!isLeadGenerationStep && !isThankYouPage && !globalLoadingSignal">
  <div class="mobile-header text-center mb-6 d-xl-none sticky-top bg-white">
    <div class="trustpilot bg-light pt-4 pb-2">
      <app-trustpilot
        [trustpilotTheme]="'light'"
        [trustpilotType]="'micro'"
        [displayClass]="'d-xl-none'"
      >
      </app-trustpilot>
    </div>
    <div class="py-4">
      <a href="/" class="text-white text-decoration-none w-100">
        <span class="fs-5">
          <img src="/assets/images/advofin-logo-colored.svg" alt="{{title}}" title="{{title}}" class="logo"/>
        </span>
      </a>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isThankYouPage">
  <router-outlet></router-outlet>
</ng-container>

<ng-container *ngIf="!isThankYouPage">
  <div class="container-fluid">
    <div class="row" [ngClass]="isThankYouPage ? '' : ' flex-xl-nowrap'">
      <div class="sidebar px-0 col-12 col-xl-6 col-xxl-5 vh-xl-100" *ngIf="sidebar"
           [ngClass]="isLeadGenerationStep ? '' : ' d-none d-xl-block'">
        <div class="col-inner p-0 p-xl-5 overflow-hidden h-100">
          <div class="sidebar-inner rounded-xl-lg bg-primary h-100 mb-5 mb-xl-0">
            <app-sidebar
              [logoPath]="getLogoPath()"
              [title]="getApplicationName()"
            ></app-sidebar>
          </div>
        </div>
      </div>

      <ng-container *ngIf="!isThankYouPage">
        <div id="main-content"
             class="col bg-white bg-xl-none mt-n6 mt-xl-0 rounded-left-top-lg vh-xl-100 py-xl-5 px-3 px-xl-0 p-xxl-0 overflow-hidden">
          <div class="col-inner h-100 overflow-xl-auto py-xl-5 px-xl-3 p-xxl-6 d-flex flex-column align-items-start">
            <ng-container *ngIf="!globalLoadingSignal">
              <div class="w-100 h-auto pe-xl-5">
                <router-outlet></router-outlet>
              </div>
            </ng-container>

            <div class="footer-wrap mt-xl-auto w-100">
              <div class="d-xl-none mt-4 mt-lg-5 d-flex flex-row w-100 justify-content-center">
                <app-trustpilot
                  [trustpilotTheme]="'light'"
                  [trustpilotType]="'mini'"
                  [displayClass]="'d-xl-none'"
                >
                </app-trustpilot>
              </div>

              <div class="w-100 pe-xl-5 my-5 mb-xl-0">
                <app-footer
                  [color]="'light-emphasis'"
                  [loading]="loaded()">
                </app-footer>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
